<template>
  <div>
    <a-card>
      <!-- 查询 -->
      <SearchView
        :renderItem="searchSchema"
        :formLayout="formLayout"
        :initialValues="searchData"
        @fetchSearch="handelSearch"
        :isExpandShowOrNot="false"
      ></SearchView>
    </a-card>
    <a-card style="margin-top:20px;">
      <div class="text-right" style="margin-bottom: 0">
        <a-button @click="_exportCreditHistory" type="primary">导出</a-button>
      </div>
      <!-- Tab -->
      <a-tabs>
        <!-- 报表 -->
        <a-tab-pane key="1" tab="报表">
          <table-tab ref="tableTab" :searchData="searchData"></table-tab>
        </a-tab-pane>
        <!-- 折线图 -->
        <a-tab-pane key="2" tab="折线图">
          <chart-tab ref="chartTab"></chart-tab>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>
<script>
import { SearchView } from 'lxfintech-fe'
import TableTab from './components/TableTab'
import ChartTab from './components/ChartTab'
import mixin from './mixin'
import { exportCreditHistory } from './api'
import { formatParamDate } from 'utils/util'

export default {
  mixins: [mixin],
  components: {
    SearchView,
    TableTab,
    ChartTab,
  },
  data() {
    return {
      formLayout: 'inline',
      companyCode: '',
    }
  },
  computed: {},
  // mounted() {
  //   this._getCCAList()
  // },
  methods: {
    // //获取CCA列表
    // _getCCAList() {
    //   for (let key in this.CCAList) {
    //     this.searchSchema[0].selectList.push({
    //       text: this.CCAList[key].label,
    //       value: this.CCAList[key].label,
    //     })
    //   }
    // },
    //点击查询
    handelSearch(data) {
      data = formatParamDate(data, data.time, 'startTime', 'endTime')
      delete data.time
      this.searchData = data
      this.$refs.tableTab.pageData.current = 1 // 设置为第一页
      this.$nextTick(() => {
        this.$refs.tableTab._getTableData()
      })
    },
    // 导出
    _exportCreditHistory() {
      const params = {
        companyId: this.$route.params.id,
        ...this.searchData,
      }
      try {
        exportCreditHistory(params)
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>

<style lang="less" scoped></style>
